/* Washington Diamond — hero carousel
   Cross-fades slides on an interval, honours prefers-reduced-motion, pauses on
   hover/focus, and stops auto-advance permanently after a manual dot click.
   One instance per section, so multiple heroes on a page cannot collide. */
(function () {
  var REDUCED = window.matchMedia('(prefers-reduced-motion: reduce)');

  function init(root) {
    if (!root || root.dataset.wdHeroReady === 'true') return;
    root.dataset.wdHeroReady = 'true';

    var slides = Array.prototype.slice.call(root.querySelectorAll('[data-wd-slide]'));
    var dots = Array.prototype.slice.call(root.querySelectorAll('[data-wd-dot]'));
    if (slides.length < 2) return;

    var interval = parseInt(root.dataset.wdInterval, 10) || 5200;
    var index = 0;
    var timer = null;
    var stopped = false;

    function paint() {
      slides.forEach(function (slide, i) {
        var on = i === index;
        slide.style.opacity = on ? '1' : '0';
        slide.style.zIndex = on ? '2' : '1';
      });
      dots.forEach(function (dot, i) {
        var on = i === index;
        dot.style.width = on ? '38px' : '14px';
        dot.style.background = on ? '#ffffff' : 'rgba(255,255,255,0.55)';
        dot.setAttribute('aria-current', on ? 'true' : 'false');
      });
    }

    function advance() {
      index = (index + 1) % slides.length;
      paint();
    }

    function start() {
      if (stopped || timer || REDUCED.matches) return;
      timer = window.setInterval(advance, interval);
    }

    function pause() {
      if (timer) {
        window.clearInterval(timer);
        timer = null;
      }
    }

    dots.forEach(function (dot, i) {
      dot.addEventListener('click', function () {
        stopped = true;
        pause();
        index = i;
        paint();
      });
    });

    root.addEventListener('mouseenter', pause);
    root.addEventListener('mouseleave', start);
    root.addEventListener('focusin', pause);
    root.addEventListener('focusout', start);

    document.addEventListener('visibilitychange', function () {
      if (document.hidden) pause();
      else start();
    });

    if (REDUCED.addEventListener) {
      REDUCED.addEventListener('change', function () {
        if (REDUCED.matches) pause();
        else start();
      });
    }

    paint();
    start();
  }

  function initAll() {
    document.querySelectorAll('[data-wd-hero]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  // Theme editor re-renders the section on every setting change.
  document.addEventListener('shopify:section:load', function (e) {
    var root = e.target.querySelector('[data-wd-hero]');
    if (root) init(root);
  });
})();
